<template>
  <section
    v-if="isEnabled"
    class="flex flex-col max-sm:items-center xs:border xs:border-gray-200 max-w-[250px] py-2 bg-white"
  >
    <!-- Filters Header -->
    <div class="flex flex-row w-full items-center px-4 mb-1">
      <div class="flex flex-col">
        <span
          class="text-lg leading-7 font-medium"
          :style="{ color: textColor }"
          >Filters</span
        >
      </div>
      <div class="flex-1 flex justify-center">
        <span
          class="text-lg leading-7 font-medium px-2 py-1 rounded-md"
          :style="{
            color: textColor,
            backgroundColor: backgroundColor,
          }"
        >
          Clear all
        </span>
      </div>
      <div class="flex flex-col">
        <div class="w-5 h-5">☰</div>
      </div>
    </div>

    <!-- Search Bars -->
    <div class="flex flex-col items-center gap-4">
      <!-- Name Search -->
      <div class="flex flex-col w-full gap-3">
        <div class="flex flex-row items-center gap-2 px-4 mb-1">
          <span
            class="text-base font-medium leading-5 tracking-wide"
            :style="{ color: backgroundColor }"
          >
            Name
          </span>
        </div>
        <div class="flex items-center w-full px-4 mb-1">
          <div class="relative w-full">
            <div class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
              <div v-html="SEARCH_ICON" class="w-5 h-5"></div>
            </div>
            <input
              type="text"
              placeholder="Search by name"
              class="w-full pl-10 pr-24 py-2 border border-gray-300 rounded-lg focus:outline-none"
              disabled
            />
            <span
              class="absolute right-1 top-1/2 -translate-y-1/2 px-2 py-1 rounded-md"
              :style="{
                color: textColor,
                backgroundColor: backgroundColor,
              }"
            >
              Search
            </span>
          </div>
        </div>
        <hr class="border-t border-gray-200" />
      </div>

      <!-- Language Search -->
      <div class="flex flex-col w-full gap-3">
        <div class="flex flex-row items-center gap-2 px-4 mb-1">
          <span
            class="text-base font-medium leading-5 tracking-wide"
            :style="{ color: backgroundColor }"
          >
            Language
          </span>
        </div>
        <div class="flex items-center w-full px-4 mb-1">
          <div class="relative w-full">
            <div class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
              <div v-html="SEARCH_ICON" class="w-5 h-5"></div>
            </div>
            <input
              type="text"
              placeholder="Search by language"
              class="w-full pl-10 pr-24 py-2 border border-gray-300 rounded-lg focus:outline-none"
              disabled
            />
            <span
              class="absolute right-1 top-1/2 -translate-y-1/2 px-2 py-1 rounded-md"
              :style="{
                color: textColor,
                backgroundColor: backgroundColor,
              }"
            >
              Search
            </span>
          </div>
        </div>
        <hr class="border-t border-gray-200" />
      </div>

      <!-- Location Search -->
      <div class="flex flex-col w-full gap-3">
        <div class="flex flex-row items-center gap-2 px-4 mb-1">
          <span
            class="text-base font-medium leading-5 tracking-wide"
            :style="{ color: backgroundColor }"
          >
            Location
          </span>
        </div>
        <div class="flex items-center w-full px-4 mb-1">
          <div class="relative w-full">
            <div class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
              <div v-html="SEARCH_ICON" class="w-5 h-5"></div>
            </div>
            <input
              type="text"
              placeholder="Search by location"
              class="w-full pl-10 pr-24 py-2 border border-gray-300 rounded-lg focus:outline-none"
              disabled
            />
            <span
              class="absolute right-1 top-1/2 -translate-y-1/2 px-2 py-1 rounded-md"
              :style="{
                color: textColor,
                backgroundColor: backgroundColor,
              }"
            >
              Search
            </span>
          </div>
        </div>
        <hr class="border-t border-gray-200" />
      </div>

      <!-- Soonest Availability -->
      <div class="flex flex-col w-full text-left gap-2">
        <div class="flex flex-row px-4 items-center gap-2">
          <div
            v-html="SECONDARY_CALENDAR_ICON"
            class="w-5 h-5"
            :style="{ color: backgroundColor }"
          ></div>
          <span
            class="text-base font-medium leading-5 tracking-wide"
            :style="{ color: backgroundColor }"
          >
            Soonest availability
          </span>
        </div>
        <div class="flex flex-col items-start px-4 gap-2">
          <span
            class="text-sm font-medium leading-5 tracking-wide rounded-full px-2 py-1 bg-gray-100 text-gray-400"
          >
            ASAP (Within next 2 hrs)
          </span>
        </div>
        <div class="flex flex-col w-full text-left rounded-md px-4">
          <p class="text-gray-500 text-sm font-normal leading-5">
            All times listed in UTC timezone.
          </p>
        </div>
        <hr class="border-t border-gray-200 mt-1" />
      </div>

      <!-- Tags -->
      <div class="flex flex-col w-full text-left gap-2 mb-1">
        <div class="flex flex-row px-4 items-center gap-2">
          <div v-html="STARS_ICON" class="w-5 h-5"></div>
          <span
            class="text-base font-medium leading-5 tracking-wide"
            :style="{ color: backgroundColor }"
            >Tags</span
          >
        </div>
        <div class="flex flex-col px-4 max-w-[200px]">
          <div class="flex flex-wrap gap-2 mt-3">
            <span
              class="flex items-center rounded-md px-3 py-1.5 bg-gray-200 text-gray-500 text-sm"
            >
              Tag 1
            </span>
            <span
              class="flex items-center rounded-md px-3 py-1.5 bg-gray-200 text-gray-500 text-sm"
            >
              Tag 2
            </span>
            <span
              class="flex items-center rounded-md px-3 py-1.5 bg-gray-200 text-gray-500 text-sm"
            >
              Tag 3
            </span>
          </div>
          <hr class="border-t border-gray-200 mt-1" />
        </div>
      </div>

      <!-- Expert Program Area -->
      <div class="flex flex-col px-4">
        <div class="relative">
          <div
            class="absolute rounded-md inset-0 w-full h-full pointer-events-none overflow-hidden"
          >
            <div
              v-html="JOIN_EXPERT_PROGRAM_BACKGROUND"
              class="w-full h-full"
              :style="{
                color: `color-mix(in srgb, ${backgroundColor} 80%, black 20%)`,
                backgroundColor: backgroundColor,
              }"
            ></div>
          </div>
          <div
            class="relative flex flex-col gap-2 px-4 py-2 rounded-md text-left justify-between bg-no-repeat bg-cover"
            :style="{ color: textColor }"
          >
            <div class="flex flex-row justify-between">
              <span class="text-lg leading-9 font-medium"
                >Are you an Expert?</span
              >
              <div
                v-html="DOLLAR_ICON"
                class="w-5 h-5"
                :style="{ color: textColor }"
              ></div>
            </div>
            <div class="flex flex-col">
              <span class="text-sm leading-5 font-medium"
                >Earn with your expertise</span
              >
            </div>
            <div class="flex flex-col items-center text-center">
              <span
                class="px-4 py-2 w-full border border-gray-300 rounded-md bg-transparent text-xs sm:text-sm font-medium leading-5 bg-white"
                :style="{ color: backgroundColor }"
              >
                Join our Expert Program
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  SEARCH_ICON,
  SECONDARY_CALENDAR_ICON,
  STARS_ICON,
  DOLLAR_ICON,
  JOIN_EXPERT_PROGRAM_BACKGROUND,
} from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "StaticSearchFilters",
  props: {
    isEnabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    textColor: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      SEARCH_ICON,
      SECONDARY_CALENDAR_ICON,
      STARS_ICON,
      DOLLAR_ICON,
      JOIN_EXPERT_PROGRAM_BACKGROUND,
    };
  },
});
</script>
